"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { invoiceMatching } from "@/content/agent-use-cases/invoice-matching";

export default function InvoiceMatchingUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={invoiceMatching} locale={locale} />;
}
